const IconHamburgerMobile = () => {
  return (
    <>
      <rect x="11" y="12" width="14" height="1.8" fill="currentColor" />
      <rect x="11" y="17" width="14" height="1.8" fill="currentColor" />
      <rect x="11" y="22" width="14" height="1.8" fill="currentColor" />
    </>
  );
};

export default IconHamburgerMobile;
